import { render, staticRenderFns } from "./DeleteTruck.vue?vue&type=template&id=279b6bba&scoped=true"
import script from "./DeleteTruck.vue?vue&type=script&lang=js"
export * from "./DeleteTruck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279b6bba",
  null
  
)

export default component.exports